export function InputTextIcon({ ...props }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.6667 3.66667H11.8667C12.6134 3.66667 12.9868 3.66667 13.272 3.81199C13.5229 3.93982 13.7269 4.1438 13.8547 4.39468C14 4.67989 14 5.05326 14 5.8V9.2C14 9.94674 14 10.3201 13.8547 10.6053C13.7269 10.8562 13.5229 11.0602 13.272 11.188C12.9868 11.3333 12.6134 11.3333 11.8667 11.3333H7.6667M5.00003 3.66667H3.80003C3.05329 3.66667 2.67992 3.66667 2.39471 3.81199C2.14383 3.93982 1.93985 4.1438 1.81202 4.39468C1.6667 4.67989 1.6667 5.05326 1.6667 5.8V9.2C1.6667 9.94674 1.6667 10.3201 1.81202 10.6053C1.93985 10.8562 2.14383 11.0602 2.39471 11.188C2.67992 11.3333 3.05329 11.3333 3.80003 11.3333H5.00003M5.00003 14L5.00003 1M3.33336 1.00001L6.6667 1M3.33336 14L6.6667 14"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 7.6H8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}
